<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
}
</script>

<style>
  #app{
    width: 100%;
    /*overflow: scroll;*/
  }
body{
  /*min-width: 1200px;*/
  background: rgb(247, 247, 247);
  color: #555;
  font-size: 14px;
  font-family: '微软雅黑', sans-serif;
  width: 100%;
  margin: 0 auto;
}
body,div,dl,dt,dd,ul,ol,li,h1,h2,h3,h4,h5,h6,pre,code,form,fieldset,legend,input,button,textarea,p,blockquote,th,td { margin:0; padding:0; }
td,th,caption { font-size:14px; }
h1, h2, h3, h4, h5, h6 { font-weight:normal; font-size:100%; }
address, caption, cite, code, dfn, em, th, var { font-style:normal; font-weight:normal;}
a { color:#555; text-decoration:none;  -webkit-transition: all .3s; -moz-transition: all .3s; transition: all .3s;
}
a:hover { text-decoration:underline;  -webkit-transition: all .3s; -moz-transition: all .3s; transition: all .3s;
}
img { border:none;}
ol,ul,li { list-style:none; }
input, textarea, select, button { font:14px Verdana,Helvetica,Arial,sans-serif; }
table { border-collapse:collapse; }
html {overflow-y: scroll;}
  .el-input__inner{
    background: #F7F7F7!important;
  }
  .el-input__inner::placeholder{
    color: #000;
  }
  .el-textarea__inner{
    background:#F7F7F7!important;
    width: 598px!important;
    height: 120px!important;
  }
  .el-textarea__inner::placeholder{
    color: #000;
  }
  .el-form--inline .el-form-item__content{
    width: 300px;
  }
  .el-button{
    width: 155px;
    height: 40px;
    text-align: center;
    border: 1px solid #8ec31f;
    color: #8ec31f;
    font-size: 16px;
    display: block;
    text-decoration: none;  }
  .el-button:hover{
    background: #8ec31f;
    color: #fff;
  }
  .swiper-pagination-bullet-active{
    background: #fff!important;
  }
  .el-pagination.is-background .el-pager li {
    margin: 0 5px;
    background-color: #fff;
    color: #8ec31f!important;
    min-width: 30px;
    border-radius: 2px;
    border: 1px solid #8ec31f;
  }
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #8ec31f!important;
    color: #fff!important;
  }
  .el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev {
    margin: 0 5px!important;
    background-color: #fff!important;
    color: #8ec31f!important;
    min-width: 30px!important;
    border-radius: 2px!important;
    border: 1px solid #8ec31f!important;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue